import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useData } from '../context/DataContext';

export const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  const { faqs: dbFaqs, loading } = useData();

  const defaultFaqs = [
    {
      question: "Como funciona el proceso de contratacion?",
      answer: "Iniciamos con una consulta gratuita para entender tus necesidades, despues desarrollamos una propuesta personalizada y finalmente implementamos la solucion. Todo el proceso es transparente y colaborativo."
    },
    {
      question: "Cuanto tiempo toma implementar una solucion?",
      answer: "El tiempo de implementacion varia segun la complejidad del proyecto. Soluciones simples pueden estar listas en 1-2 semanas, mientras que proyectos mas complejos pueden tomar 4-8 semanas."
    },
    {
      question: "Ofrecen soporte tecnico en espanol?",
      answer: "Si, nuestro equipo de soporte tecnico esta disponible 24/7 en espanol. Puedes contactarnos por chat, email o telefono en cualquier momento."
    },
    {
      question: "Pueden integrar con nuestros sistemas existentes?",
      answer: "Absolutamente. Nos especializamos en integrar nuestras soluciones con los sistemas que ya utilizas, incluyendo CRM, ERP, bases de datos y otras herramientas empresariales."
    },
    {
      question: "Que garantias ofrecen sobre los resultados?",
      answer: "Ofrecemos una garantia de satisfaccion de 90 dias. Si no ves mejoras medibles en tus procesos, te devolvemos tu inversion sin preguntas."
    }
  ];

  const faqs = dbFaqs.length > 0 ? dbFaqs : defaultFaqs;

  const toggleFAQ = (index) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  if (loading) {
    return (
      <section id="faq" className="py-24 lg:py-32 bg-secondary/50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <div className="h-4 w-24 bg-foreground/10 rounded-full mx-auto mb-4 animate-pulse" />
            <div className="h-12 w-96 bg-foreground/10 rounded-lg mx-auto mb-4 animate-pulse" />
            <div className="h-6 w-3/4 bg-foreground/10 rounded-lg mx-auto animate-pulse" />
          </div>
          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="bg-card border border-border rounded-2xl p-6">
                <div className="h-6 w-3/4 bg-foreground/10 rounded animate-pulse" />
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="faq" className="py-24 lg:py-32 bg-secondary/50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-accent uppercase tracking-[0.2em] mb-4 block">
            FAQ
          </span>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-foreground leading-tight mb-4 text-balance">
            Preguntas frecuentes
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto leading-relaxed">
            Respuestas a las dudas mas comunes sobre nuestros servicios
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-card border border-border rounded-2xl overflow-hidden transition-all duration-300 hover:border-foreground/15"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full p-6 lg:p-8 text-left flex items-center justify-between hover:bg-foreground/[0.02] transition-colors duration-200"
              >
                <h3 className="text-base lg:text-lg font-semibold text-foreground pr-6">
                  {faq.question}
                </h3>
                <ChevronDown
                  className={`h-5 w-5 text-muted-foreground flex-shrink-0 transition-transform duration-300 ${
                    openFAQ === index ? 'rotate-180' : ''
                  }`}
                />
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openFAQ === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 lg:px-8 pb-6 lg:pb-8">
                  <div className="border-t border-border pt-4">
                    <p className="text-muted-foreground leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-4">
            No encuentras la respuesta que buscas?
          </p>
          <a
            href="#contacto"
            className="inline-flex items-center text-foreground hover:text-accent font-medium transition-colors duration-300 border-b border-foreground/20 hover:border-accent pb-0.5"
          >
            Contactanos directamente
          </a>
        </div>
      </div>
    </section>
  );
};
